import styled from 'styled-components';

import { utils } from '@frontend/partviewer';

const { formatEntityMetaData } = utils;

const MetaDataContainer = styled.div`
  color: inherit;
  font-size: 13px;
  line-height: 1.5;
  margin-bottom: 10px;
  pointer-events: none;
  text-align: right;
  width: 200px;
`;

const Title = styled.span`
  font-weight: 700;
  margin-bottom: 5px;
`;

const MetaDataList = styled.div`
  display: flex;
  flex-direction: column;
`;

const EntryWrapper = styled.div``;

const EntryTitle = styled.span`
  margin-right: 5px;
`;

const EntryValue = styled.span``;

const MetaDataDisplayComponent = ({
  displayScale,
  displayUnits,
  dimensionalPrecision,
  metaData,
  nativeUnits,
}) => {
  const formattedMetaData = formatEntityMetaData(
    metaData,
    displayUnits,
    nativeUnits,
    dimensionalPrecision,
    displayScale,
  );
  return formattedMetaData.length > 0 ? (
    <MetaDataContainer>
      <Title>Selection Data</Title>
      <MetaDataList>
        {formattedMetaData.map((entry) => (
          <EntryWrapper key={entry.title}>
            <EntryTitle>{`${entry.title}:`}</EntryTitle>
            <EntryValue>{entry.payload}</EntryValue>
          </EntryWrapper>
        ))}
      </MetaDataList>
    </MetaDataContainer>
  ) : null;
};

export default MetaDataDisplayComponent;
